/**
 * 格式化钱
 *
 * @export
 * @param {number} amount 要格式化的数字
 * @param {number} [base=100] 格式化基数,默认为100
 * @returns
 */
export function formatMoney(amount: number, base: number = 100): number | string {
	if (base === 1) {
		return amount;
	}

	// 解决类似amount=1990时的精数不准问题
	if (Math.floor(amount) === amount) {
		return Number(amount || 0) / base;
	}

	// 解决类似 11.11/100 的精数不准问题
	let money: string = (Math.floor((amount / base) * base) / base).toFixed(2);

	return money;
}

/**
 * 图片格式化
 *
 * @param {string} url
 * @param {string} [formatStrQ="?x-oss-process=image/resize,m_fill,limit_0,h_64,w_64"] 阿里云的裁剪规格  例如："@96h_96w_1e_1c_2o"
 * @param {string} [formatStrW="/64"] 微信的裁剪规格 例如："/96"
 * @returns
 */
export const imgUrlFormat: any = (url: string, formatStrQ: string = '?x-oss-process=image/resize,m_fill,limit_0,h_64,w_64', formatStrW: string = '/64'): string => {
	let imgUrl: string = '';
	if (/(img\.qlchat\.com)/.test(url)) {
		imgUrl = url.replace(/@.*/, '') + formatStrQ;
	} else if (/(wx\.qlogo\.cn\/mmopen)/.test(url)) {
		imgUrl = url.replace(/(\/(0|132|64|96)$)/, formatStrW);
	}

	return imgUrl;
};

/**
 * 数字格式化成万或千
 * digitFormat
 * @export
 * @param {any} digit 数字
 * @param {any} block 格式化基数
 * @returns
 */
export function digitFormat(digit: number, block: number = 10000, fromat?: string[]): any {
	try {
		const format: number = Math.floor(block);
		let formateDigit: number = null;
		formateDigit = Math.floor(digit);
		let f: string[] = fromat || ['千', '万'];

		if (formateDigit >= 1000 && formateDigit < 10000 && format <= 1000) {
			formateDigit = formateDigit / 1000;

			return formateDigit.toFixed(1) + f[0];
		} else if (formateDigit > 10000 && formateDigit >= format) {
			formateDigit = formateDigit / 10000;

			return formateDigit.toFixed(1) + f[1];
		}

		return formateDigit;
	} catch (error) {
		return 0;
	}
}

/**
 * 将秒数格式化成时分秒的形式
 *  @param paramsDuration {number} 时长(秒)
 *  @param chinese {boolean} 是否使用中文单位
 *  @returns "hh:mm:ss | hh小时mm分钟ss秒"
 */
export function formatSecondsDuration(paramsDuration: number, chinese: boolean = false): any {
	let duration: number = Number(paramsDuration);
	if (duration !== duration) {
		return '--';
	}
	duration = Math.floor(duration);
	// tslint:disable-next-line:no-magic-numbers
	let hours: number | string = Math.floor(duration / 3600);
	// tslint:disable-next-line:no-magic-numbers
	let minutes: number | string = Math.floor((duration % 3600) / 60);
	// tslint:disable-next-line:no-magic-numbers
	let seconds: number | string = duration % 60;
	hours = hours < 10 ? `0${hours}` : hours;
	minutes = minutes < 10 ? `0${minutes}` : minutes;
	seconds = seconds < 10 ? `0${seconds}` : seconds;
	if (chinese) {
		let ret: string = '';
		if (hours > 0) {
			ret += `${hours}小时`;
		}
		if (minutes > 0) {
			ret += `${minutes}分钟`;
		}
		if (seconds > 0) {
			ret += `${seconds}秒`;
		}

		return ret;
	} else if (hours > 0) {
		return `${hours}:${minutes}:${seconds}`;
	} else {
		return `${minutes}:${seconds}`;
	}
}

/**
 * 格格式输出日期串
 * @param date      {Number/Date}   要格式化的日期
 * @param formatStr {String}        格式串(yMdHmsqS)
 * @returns {*|string}
 */
export function formatDate(dateParam: any, formatStr?: string): any {
	if (!dateParam) {
		return '';
	}

	let format: string = formatStr || 'yyyy-MM-dd';
	let date: any = null;

	if ('number' === typeof dateParam || 'string' === typeof dateParam) {
		date = new Date(+dateParam);
	}

	let map: any = {
		M: Number(date.getMonth()) + 1, // 月份
		d: date.getDate(), // 日
		h: date.getHours(), // 小时
		m: date.getMinutes(), // 分
		s: date.getSeconds(), // 秒
		q: Math.floor((Number(date.getMonth()) + 3) / 3), // 季度
		S: date.getMilliseconds(), // 毫秒
	};

	let patterns: any = [/(y)+/g, /(M)+/g, /(d)+/g, /(h)+/g, /(m)+/g, /(s)+/g, /(q)+/g, /(S)+/g];

	patterns.map((p: any): void => {
		// tslint:disable-next-line:only-arrow-functions
		format = format.replace(p, function (all: any, t: any): any {
			let v: number | string = map[t];
			if (v !== undefined) {
				if (all.length > 1) {
					v = '0' + v.toString();
					v = v.substr(v.length - 2);
				}

				return v;
			} else if (t === 'y') {
				const year: string = date.getFullYear().toString();

				return (year + '').substr(4 - all.length);
			}

			return all;
		});
	});

	return format;
}

/**
 * 根据时间戳显示周几的字符串
 * @param  {[type]} startTime [description]
 * @return {[type]}           [description]
 */
export const formateToDay: any = (startTime: any, nowTime: any, showToday: boolean = false): any => {
	let timeNow: any = nowTime || parseInt(new Date().getTime().toString(), 10);
	let d_days: any = Math.abs((startTime - timeNow) / 1000);
	let timeDay: any = new Date(startTime).getDay();
	// tslint:disable-next-line:no-magic-numbers
	if (!showToday && d_days >= 0 && d_days <= 86400 && timeDay === new Date(timeNow).getDay()) {
		return '今天';
	} else {
		switch (timeDay) {
			case 1:
				return '周一';
				break;
			case 2:
				return '周二';
				break;
			case 3:
				return '周三';
				break;
			case 4:
				return '周四';
				break;
			case 5:
				return '周五';
				break;
			case 6:
				return '周六';
				break;
			case 0:
				return '周日';
				break;
			default:
				break;
		}
	}
};

// 换行符处理
export const replaceWrapWord: (strParams: string) => any = (strParams: string): any => {
	console.log(/\n\r/.test(strParams));
	let str: string = strParams || '';
	str = str.replace(/\</g, (m: any): any => '&lt;');
	str = str.replace(/\>/g, (m: any): any => '&gt;');

	return str.replace(/\n/g, (m: any): any => '</br>');
};

export const dangerHtml: (content: string) => any = (content: string): any => {
	return { __html: content };
};

/**
 * 获取媒体时间格式化字符串
 */
export function getAudioTimeShow(secs: number, hasHour: boolean = false): string {
	// 小时
	let hours: any = Math.floor(secs / 3600);
	if (hours < 10) {
		hours = `0${hours}`;
	}
	// 分钟
	let minutes: any = Math.floor(secs / 60);
	if (minutes < 10) {
		minutes = `0${minutes}`;
	}
	// 秒
	let seconds: any = Math.round(secs % 60);
	if (seconds < 10) {
		seconds = `0${seconds}`;
	}

	if (hasHour) {
		minutes = Math.floor((secs % 3600) / 60);
		if (minutes < 10) {
			minutes = `0${minutes}`;
		}

		return `${hours}:${minutes}:${seconds}`;
	} else {
		return `${minutes}:${seconds}`;
	}
}

/**
 * 格式化倒计时时间显示
 *
 * @export
 * @param {*} second
 * @param {*} formatStr
 * @param {boolean} flag
 * @returns
 */
export function formatCountdown(sec: any, formatStr: any, flag: boolean = false): string {
	if (!sec && !Object.is(sec, 0)) {
		return '';
	}

	let format: string = formatStr || 'd';

	const second: number = Number(sec);
	const map: any = {
		d: ~~(second / (3600 * 24)), // 日
		h: ~~((second % (3600 * 24)) / 3600), // 小时
		m: ~~((second % 3600) / 60), // 分
		s: second % 60, // 秒
	};
	if (flag) {
		return map;
	} else {
		format = format.replace(/([dhms])+/g, (all: any, t: any): string => {
			let v: any = map[t];

			if (v !== undefined) {
				if (all.length > 1) {
					v = `0${v}`;
					v = v.substr(v.length - 2);
				}

				return v;
			} else if (t === 'd') {
				return v;
			}

			return all;
		});

		return format;
	}
}
